import { motion } from "framer-motion";
import { IMAGES, CHAPTERS, STATS } from "@/data/news";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 1, 0.5, 1] } },
};

const Chapter = ({ chapter, index }) => (
  <motion.section
    data-testid={`article-chapter-${chapter.num}`}
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    className="border-t border-white/10 pt-12"
  >
    <div className="flex items-baseline gap-6 mb-8">
      <span className="font-display text-6xl sm:text-7xl text-outline leading-none">{chapter.num}</span>
      <h2 className="font-display text-4xl sm:text-5xl text-white tracking-tight leading-none">{chapter.title}</h2>
    </div>
    <div className="space-y-6">
      {chapter.paragraphs.map((p, i) => (
        <p
          key={i}
          className={`text-base sm:text-lg text-zinc-300 leading-relaxed ${index === 0 && i === 0 ? "drop-cap" : ""}`}
        >
          {p}
        </p>
      ))}
    </div>
    {chapter.image && (
      <motion.figure
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
        className="mt-10"
      >
        <div className="img-frame scanlines">
          <img src={IMAGES[chapter.image.src]} alt={chapter.image.caption} className="w-full object-cover" loading="lazy" />
        </div>
        <figcaption className="mt-3 font-mono-news text-xs text-zinc-500 uppercase tracking-widest">
          {chapter.image.caption}
        </figcaption>
      </motion.figure>
    )}
  </motion.section>
);

export const Article = () => (
  <div id="article" data-testid="main-article" className="space-y-20">
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="pt-4"
    >
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 font-mono-news text-xs text-zinc-500 uppercase tracking-widest mb-6">
        <span className="text-[#4ADE80]">The Headline Story</span>
        <span>By MCNews24 Field Desk</span>
        <span>Filed from somewhere in the taiga</span>
      </div>
      <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.95] max-w-3xl">
        Off the grid, on the ladder: inside Liger's wilderness hiatus
      </h2>
    </motion.div>

    <motion.div
      data-testid="hiatus-stats"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-60px" }}
      className="grid grid-cols-2 lg:grid-cols-4 border border-white/10"
    >
      {STATS.map((s, i) => (
        <div key={s.label} className={`p-6 ${i !== 0 ? "border-l border-white/10" : ""} ${i >= 2 ? "border-t lg:border-t-0 border-white/10" : ""}`}>
          <div className="font-display text-4xl sm:text-5xl text-[#4ADE80]">{s.value}</div>
          <div className="font-mono-news text-[10px] sm:text-xs text-zinc-500 uppercase tracking-widest mt-2">{s.label}</div>
        </div>
      ))}
    </motion.div>

    {CHAPTERS.map((chapter, i) => (
      <Chapter key={chapter.num} chapter={chapter} index={i} />
    ))}
  </div>
);
